import React from 'react';
import { uniqueId } from '@epl/helpers';
import styled from 'styled-components';
import { rem } from 'polished';
import PropTypes from 'prop-types';
import { breakpoints } from '../ModalUpsell.styles';

const CECreditFutureSVG = styled.svg`
  margin: ${rem(20)} auto ${rem(-14)};
  display: block;
  width: '80%';
  max-width: ${`${rem(112)}`};
  height: auto;

  @media only screen and (min-width: ${breakpoints.mobile}) {
    width: ${`${rem(80)}`};
  }
`;

const CECreditFuture = ({ className }) => {
  const uniqueIdSuffix = uniqueId('feature');

  return (
    <CECreditFutureSVG className={className} viewBox="0 0 84 70" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title>Credit future icon</title>
      <g filter={`url(#a-${uniqueIdSuffix})`}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M66.296 13.478a4 4 0 0 0-4-4h-5.883a4 4 0 0 0-4 4v35.599a4 4 0 0 0 4 4h5.883a4 4 0 0 0 4-4V13.478Z"
          fill="#8CC33F"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.166 29.907a4 4 0 0 0-4-4h-5.883a4 4 0 0 0-4 4v19.17a4 4 0 0 0 4 4h5.883a4 4 0 0 0 4-4v-19.17Z"
        fill="#F79836"
      />
      <rect width="13.883" height="49.286" rx="4" transform="matrix(-1 0 0 1 83.072 3.791)" fill="#049D4A" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.812 4a4 4 0 0 0-4-4H4.929a4 4 0 0 0-4 4v45.077a4 4 0 0 0 4 4h5.883a4 4 0 0 0 4-4V4Z"
        fill="#049D4A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M49.52 22.324a4 4 0 0 0-4-4h-5.883a4 4 0 0 0-4 4v26.753a4 4 0 0 0 4 4h5.883a4 4 0 0 0 4-4V22.324Z"
        fill="#FBDD00"
      />
      <defs>
        <filter
          id={`a-${uniqueIdSuffix}`}
          x="42.413"
          y="9.478"
          width="33.883"
          height="63.599"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="10" />
          <feGaussianBlur stdDeviation="5" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1329_76780" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_1329_76780" result="shape" />
        </filter>
      </defs>
    </CECreditFutureSVG>
  );
};

CECreditFuture.defaultProps = {
  className: undefined,
};

CECreditFuture.propTypes = {
  className: PropTypes.string,
};

export default CECreditFuture;
